var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.707 20.707C14.5184 20.8892 14.2658 20.99 14.0036 20.9877C13.7414 20.9854 13.4906 20.8802 13.3052 20.6948C13.1198 20.5094 13.0146 20.2586 13.0123 19.9964C13.01 19.7342 13.1108 19.4816 13.293 19.293L19.586 13H2C1.73478 13 1.48043 12.8946 1.29289 12.7071C1.10536 12.5196 1 12.2652 1 12C1 11.7348 1.10536 11.4804 1.29289 11.2929C1.48043 11.1054 1.73478 11 2 11H19.586L13.293 4.707C13.1108 4.5184 13.01 4.2658 13.0123 4.0036C13.0146 3.7414 13.1198 3.49059 13.3052 3.30518C13.4906 3.11977 13.7414 3.0146 14.0036 3.01233C14.2658 3.01005 14.5184 3.11084 14.707 3.293L22.707 11.293C22.7996 11.3861 22.873 11.4965 22.923 11.618C22.9738 11.7389 23 11.8688 23 12C23 12.1312 22.9738 12.2611 22.923 12.382C22.873 12.5035 22.7996 12.6139 22.707 12.707L14.707 20.707Z",
    fill: "#001D9A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/ArrowRight.5d01d613c97691639beb24c52148ccbb.svg";
export { ForwardRef as ReactComponent };